import { useSwitchState } from 'hooks/useSwitchState'

const useOpenLocationInput = () => {
  const [isOpenLocationInput, , closeLocationInput, toggleOpenLocationInput] =
    useSwitchState()

  return {
    isOpenLocationInput,
    closeLocationInput,
    toggleOpenLocationInput,
  }
}

export default useOpenLocationInput
